(function () {
  // Prevent double-initialisation if the script is accidentally included twice
  if (window.__illumimountWishlistInitV1) return;
  window.__illumimountWishlistInitV1 = true;

  const STORAGE_KEY = 'wishlist_handles_v1';

  function loadHandles() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function saveHandles(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // ignore
    }
  }

  function isFavourited(list, handle) {
    return list.indexOf(handle) !== -1;
  }

  function setFavourited(list, handle, on) {
    const next = list.slice();
    const idx = next.indexOf(handle);
    if (on && idx === -1) next.push(handle);
    if (!on && idx !== -1) next.splice(idx, 1);
    return next;
  }

  function buttonsForHandle(handle) {
    return Array.from(
      document.querySelectorAll(
        '[data-wishlist-toggle][data-product-handle="' + CSS.escape(handle) + '"]'
      )
    );
  }

  function renderButtons(handle, isOn) {
    const btns = buttonsForHandle(handle);

    btns.forEach((btn) => {
      btn.classList.toggle('is-active', isOn);
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');

      const floatIcon = btn.querySelector('.pdp__wishlist-float-icon');
      const mainIcon = btn.querySelector('.pdp__wishlist-main-icon');
      const label = btn.querySelector('.pdp__wishlist-main-label');

      const heartChar = isOn ? '♥' : '♡';

      // Do not overwrite SVG hearts
      if (floatIcon) {
        const hasSvg = floatIcon.querySelector('svg');
        if (!hasSvg) floatIcon.textContent = heartChar;
      }

      if (mainIcon) {
        const hasSvg = mainIcon.querySelector('svg');
        if (!hasSvg) mainIcon.textContent = heartChar;
      }

      if (label) {
        label.textContent = isOn ? 'Saved to favourites' : 'Save to favourites';
      }
    });
  }

  async function syncWithServer(handle, added) {
    if (!window.ShopPrefs || !ShopPrefs.apiBase || !ShopPrefs.customerId) return;

    try {
      await fetch(ShopPrefs.apiBase + '/wishlist/toggle', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: ShopPrefs.customerId,
          handle: handle,
          action: added ? 'add' : 'remove'
        })
      });
    } catch (e) {
      // fail silently; local wishlist still works
    }
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    const value = (cents || 0) / 100;
    const currency =
      (window.Shopify &&
        window.Shopify.currency &&
        (window.Shopify.currency.active || window.Shopify.currency.current)) ||
      'GBP';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(value);
    } catch (e) {
      return currency + ' ' + value.toFixed(2);
    }
  }

  function heartSvgMarkup() {
    // Matches snippets/im-heart-icon.liquid, embedded here so wishlist.js can render the same icon
    return (
      '<svg class="pdp__wishlist-heart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<path d="M12 21.35 L10.55 20.03 C5.4 15.36, 2 12.28, 2 8.5 C2 5.42, 4.42 3, 7.5 3 C9.24 3, 10.91 3.81, 12 5.09 C13.09 3.81, 14.76 3, 16.5 3 C19.58 3, 22 5.42, 22 8.5 C22 12.28, 18.6 15.36, 13.45 20.03 L12 21.35 Z" />' +
      '</svg>'
    );
  }

  /* ================== BUTTON INITIALISATION (ALL PAGES) ================== */
  function initButtons() {
    function paintAll() {
      const allBtns = document.querySelectorAll('[data-wishlist-toggle][data-product-handle]');
      if (!allBtns.length) return;

      const handles = loadHandles();

      allBtns.forEach((btn) => {
        const handle = btn.dataset.productHandle;
        if (!handle) return;
        renderButtons(handle, isFavourited(handles, handle));
      });
    }

    // Paint current DOM once on load
    paintAll();

    // Delegated click handler (bubble phase). Works for dynamically injected cards too.
    document.addEventListener('click', (ev) => {
      const btn = ev.target.closest('[data-wishlist-toggle][data-product-handle]');
      if (!btn) return;

      ev.preventDefault();
      ev.stopPropagation();

      const handle = btn.dataset.productHandle;
      if (!handle) return;

      let handles = loadHandles();
      const nextOn = !isFavourited(handles, handle);

      handles = setFavourited(handles, handle, nextOn);
      saveHandles(handles);
      renderButtons(handle, nextOn);
      syncWithServer(handle, nextOn);

      // If we are on the wishlist page and a user untoggles, remove the card from the grid
      const wishlistPage = document.querySelector('[data-wishlist-page]');
      if (wishlistPage && !nextOn) {
        // IMPORTANT: target the actual card, not the button (the button also has data-product-handle)
        const card =
          btn.closest('.illumCard[data-product-handle="' + CSS.escape(handle) + '"]') ||
          btn.closest('.illumCard');
        if (card) card.remove();

        // Update count + empty state
        const listEl = wishlistPage.querySelector('[data-wishlist-list]');
        const emptyEl = wishlistPage.querySelector('[data-wishlist-empty]');
        const countEl = wishlistPage.querySelector('[data-wishlist-count]');

        const updated = loadHandles().filter(Boolean);
        if (countEl) countEl.textContent = String(updated.length);

        if (emptyEl && listEl) {
          emptyEl.hidden = updated.length > 0;
        }
      }
    });
  }

  /* ================== WISHLIST PAGE RENDERING ================== */
  async function renderWishlistPage() {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    const listEl = page.querySelector('[data-wishlist-list]');
    const emptyEl = page.querySelector('[data-wishlist-empty]');
    const countEl = page.querySelector('[data-wishlist-count]');

    if (!listEl) return;

    let handles = loadHandles().filter(Boolean);

    function updateEmptyState() {
      const count = handles.length;
      if (countEl) countEl.textContent = String(count);
      if (!count) {
        if (emptyEl) emptyEl.hidden = false;
      } else {
        if (emptyEl) emptyEl.hidden = true;
      }
    }

    async function buildList() {
      updateEmptyState();
      const currentHandles = handles.slice();

      if (!currentHandles.length) {
        listEl.innerHTML = '';
        return;
      }

      listEl.innerHTML = '';

      const products = await Promise.all(
        currentHandles.map(async (handle) => {
          try {
            const res = await fetch('/products/' + encodeURIComponent(handle) + '.js');
            if (!res.ok) throw new Error('Product fetch failed');
            const product = await res.json();
            return { handle, product };
          } catch (e) {
            return null;
          }
        })
      );

      products.forEach((entry) => {
        if (!entry || !entry.product) return;
        const p = entry.product;

        const url = p.url || '/products/' + p.handle;
        const title = p.title || '';
        const firstVariant = (p.variants && p.variants[0]) || null;
        const priceCents =
          firstVariant && typeof firstVariant.price === 'number' ? firstVariant.price : p.price;

        const image = p.featured_image || (p.images && p.images[0]) || null;

        const card = document.createElement('div');
        card.className = 'illumCard';
        card.setAttribute('data-product-handle', p.handle);

        let imgHtml = '';
        if (image) {
          imgHtml =
            '<img class="illumCardImg" src="' +
            image +
            '" alt="' +
            escapeHtml(title) +
            '">';
        } else {
          imgHtml = '';
        }

        const priceHtml =
          priceCents != null
            ? '<div class="illumCardPrice">' + formatMoney(priceCents) + '</div>'
            : '';

        card.innerHTML =
          '<div class="illumCardMedia">' +
          '<button type="button" class="pdp__wishlist-float" data-wishlist-toggle data-product-handle="' +
          escapeHtml(p.handle) +
          '" aria-label="Save to favourites">' +
          '<span class="pdp__wishlist-float-icon" aria-hidden="true">' +
          heartSvgMarkup() +
          '</span>' +
          '</button>' +
          '<a class="illumCardLink illumCardMediaLink" href="' +
          url +
          '">' +
          imgHtml +
          '</a>' +
          '</div>' +
          '<a class="illumCardLink" href="' +
          url +
          '">' +
          '<div class="illumCardMeta">' +
          '<div class="illumCardTitle" title="' +
          escapeHtml(title) +
          '">' +
          escapeHtml(title) +
          '</div>' +
          priceHtml +
          '</div>' +
          '</a>';

        listEl.appendChild(card);
      });

      // After rendering, ensure button states paint correctly
      const latestHandles = loadHandles().filter(Boolean);
      latestHandles.forEach((h) => renderButtons(h, true));
    }

    await buildList();
  }

  /* ================== ENTRYPOINT ================== */
  function initAll() {
    initButtons();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
